import { Component, OnInit } from '@angular/core';
import { res } from '../../../../common/language/text/res';
import { Strings } from '../../../../common/language/strings';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-generic-confirm-dialog',
  templateUrl: './generic-confirm-dialog.component.html',
  styleUrls: ['./generic-confirm-dialog.component.css']
})
export class GenericConfirmDialogComponent implements OnInit {
  public title: string;
  public message: string;
  public btnOkText: string;
  public btnCancelText: string;

  private confirmResult!: (result: boolean) => void;

  constructor(
    public bsModalRef: BsModalRef,
    private strings: Strings
  ) { 
    this.title = this.strings.GetText(res.Confirmation);
    this.message = this.strings.GetText(res.AreYouSureDefault);
    this.btnOkText = this.strings.GetText(res.Continue);
    this.btnCancelText = this.strings.GetText(res.Cancel);
  }

  ngOnInit(): void {
  }

  public onConfirm(): void {
    this.confirmResult(true);
    this.bsModalRef.hide();
  }

  public onCancel(): void {
    this.confirmResult(false);
    this.bsModalRef.hide();
  }

  public setConfirmationHandler(confirmResult: (result: boolean) => void) {
    this.confirmResult = confirmResult;
  }

}
